export default class  EpilogueEvent {
    constructor(type) {
        this.type = type;
    }
}

EpilogueEvent.CLOSE_REQUEST = "EpilogueEvent.CLOSE_REQUEST";
